// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_models__Atd from "../../../../packages/models/Atd.js";
import * as Buhta_models__Protocol_data_bs from "../../../../packages/models/generated/Protocol_data_bs.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";

const $$default = {
  receipt: {
    kkm_id: 0,
    id: "",
    shift_id: 0,
    serial_id: 0,
    serial_shift_id: 0,
    issue_time: undefined,
    operation_type: /* OPERATION_TYPE_UNSPECIFIED */0,
    domain_type: /* DOMAIN_TYPE_UNSPECIFIED */0,
    payment_type: /* PAYMENT_TYPE_UNSPECIFIED */0,
    items: /* [] */0,
    payments: /* [] */0,
    currency_code: /* CURRENCY_UNSPECIFIED */0,
    subtotal_amount: "",
    total_amount: "",
    taxes: /* [] */0,
    taken_amount: undefined,
    change_amount: undefined,
    cashier_code: 0,
    cashier_name: "",
    receipt_num: undefined,
    org: undefined,
    kkm: undefined,
    ofd_receipt_id: "",
    ofd_qr_code: "",
    notes: /* [] */0
  },
  etpOrder: {
    etp_info: undefined,
    order_num: "",
    details: /* [] */0,
    receipts: /* [] */0
  }
};

function initValue_1(param) {
  
}

const initValue = [
  $$default,
  initValue_1
];

const context = React.createContext(initValue);

function useData(param) {
  return React.useContext(context);
}

const Context = {
  initValue: initValue,
  context: context,
  useData: useData
};

const make = context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

const Provider = {
  make: make,
  makeProps: makeProps
};

function useContext(initialData) {
  const match = React.useReducer((function (data, action) {
          if (action.TAG === /* Receipt */0) {
            return {
                    receipt: action._0,
                    etpOrder: data.etpOrder
                  };
          } else {
            return {
                    receipt: data.receipt,
                    etpOrder: action._0
                  };
          }
        }), initialData);
  return [
          match[0],
          match[1]
        ];
}

function encode(param) {
  return Buhta_models__Atd.encode(Buhta_models__Protocol_data_bs.write_t, param);
}

function decode(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_data_bs.read_t, param);
}

function getData(param) {
  return Belt__Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(typeof __DATA__ === "undefined" ? undefined : __DATA__), $$default, (function (serialized) {
                return Buhta_models__Atd.decode(Buhta_models__Protocol_data_bs.read_t, serialized);
              }));
}

function handleResponse(res, dispatch) {
  if (res.TAG === /* Receipt */0) {
    return Curry._1(dispatch, {
                TAG: /* Receipt */0,
                _0: res._0
              });
  }
  
}

export {
  $$default as default,
  Context ,
  Provider ,
  useContext ,
  encode ,
  decode ,
  getData ,
  handleResponse ,
}
/* context Not a pure module */
